module.exports = __webpack_public_path__ + "static/img/1958_09_30_Rhein-Neckar-Azeitung.2553caa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/1958_09_30_Rhein-Neckar-Azeitung.jpg
// module id = CWIg
// module chunks = 0